import { useAccountStore } from '@jwp/ott-common/src/stores/AccountStore';
import type { PlaylistItem } from '@jwp/ott-common/types/playlist';
import { useCallback } from 'react';
import { useLocation, useNavigate, type SetURLSearchParams } from 'react-router';

import { modalURLFromLocation } from '../utils/location';

export default function useSeriesHandlers(
  setSearchParams: SetURLSearchParams,
  searchParams: URLSearchParams,
  nextItem: PlaylistItem | undefined,
  setEpisodeId: (id: string | null) => void,
  areEpisodesEntitled: { [mediaid: string]: boolean },
  feedId?: string | null,
) {
  const navigate = useNavigate();
  const location = useLocation();
  const isLoggedIn = useAccountStore((state) => !!state.user);

  const handlePlay = useCallback(() => {
    setSearchParams({ ...searchParams, r: feedId || '', play: '1' }, { replace: true });
  }, [setSearchParams, searchParams, feedId]);

  const handleBack = useCallback(() => {
    setSearchParams({ ...searchParams, r: feedId || '' });
  }, [setSearchParams, searchParams, feedId]);

  const handleComplete = useCallback(() => {
    setEpisodeId(nextItem ? nextItem.mediaid : null);
    if (!nextItem?.mediaid) {
      setSearchParams({ ...searchParams, play: '0' }, { replace: true });
    }
  }, [nextItem, setEpisodeId, setSearchParams, searchParams]);

  const handlePlayEpisode = useCallback(
    (item: PlaylistItem) => {
      if (areEpisodesEntitled[item.mediaid]) {
        setEpisodeId(item.mediaid);
        setSearchParams({ ...searchParams, r: feedId || '', play: '1' }, { replace: true });

        return;
      }

      return navigate(modalURLFromLocation(location, isLoggedIn ? 'choose-offer' : 'create-account'));
    },
    [setSearchParams, setEpisodeId, searchParams, feedId, isLoggedIn, navigate, location, areEpisodesEntitled],
  );

  return {
    handlePlay,
    handlePlayEpisode,
    handleBack,
    handleComplete,
  };
}
